import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Replace with your Firebase project config (Get this from Firebase Console)
const firebaseConfig = {
  apiKey: "AIzaSyAzSlxZDb0h1xTCnc0cKpfpwU4BsUDdcuE",
  authDomain: "ipl-predictor-41d85.firebaseapp.com",
  projectId: "ipl-predictor-41d85",
  storageBucket: "ipl-predictor-41d85.firebasestorage.app",
  messagingSenderId: "518147569739",
  appId: "1:518147569739:web:6e1f1cff8a5849061cf5ce",
  measurementId: "G-S76SG6EQ2D"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
